import {useCallback, useEffect, useState} from 'react';
import { customerModelData } from '../../services/ModelService';
import {Charter} from '../../model/charter';
import { values } from 'lodash';

export default function useAllCustomers() {
    const [allCustomers, setAllCustomers] = useState(null);

    useEffect(() => {
        const load = async () => {
            try {
                const customers = await customerModelData.getAll();
                setAllCustomers(customers);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
            }
        };

        load().then(() => console.log('Customer List Updated.'));

        const listener = customerModelData.addListener({
            setterFn: customers => setAllCustomers(customers), loaded: customers => {
                setAllCustomers(customers);
            }
        });

        return () => {
            if(listener) {
                customerModelData.removeListener(listener);
            }
        }
    }, [setAllCustomers])

    return {
        allCustomers,
        allCustomersAsArray: values(allCustomers)
    };
}